import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Checkbox, FormControlLabel, Stack } from "@mui/material";
import { DateIconSvg, ListIconSvg, PersonIconSvg } from "../../images/SvgIcons";

export default function UserFilterproperties() {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  return (
    <>
      <Button variant="outlined" onClick={handleClickOpen}>
        Open responsive dialog
      </Button>
      <Dialog
        className="user-filter-popup"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "16px 20px", borderBottom: "1px solid #EDEDED" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Typography className="model-title">Filter Properties</Typography>
          <Button
            className="edit-btn"
            variant="outlined"
            startIcon={<span class="material-symbols-outlined">history</span>}
          >
            Reset Filter
          </Button>
        </Stack>
        <Box
          sx={{
            // flexGrow: 1,
            bgcolor: "background.paper",
            display: "flex",
            // height: 224,
            borderBottom: "1px solid #EDEDED",
          }}
        >
          <Tabs
            orientation="vertical"
            // variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            sx={{
              borderRight: 1,
              borderColor: "#EDEDED",
              overflow: "unset",
            }}
          >
            <Tab icon={<PersonIconSvg />} iconPosition="start" label="Users" />
            <Tab icon={<ListIconSvg />} iconPosition="start" label="Type" />
            <Tab
              icon={<DateIconSvg />}
              iconPosition="start"
              label="Item Three"
            />
          </Tabs>
          <TabPanel value={value} index={0}>
            <Box className="user-tab-panel filter-tab-panel">
              <FormControlLabel
                className="checkbox"
                control={
                  <Checkbox
                    sx={{ color: "gray" }}
                    // value={checkeRemeber}
                    // onClick={handleRemember}
                  />
                }
                label="Admin Test (gabrielv+admin@apptomate.co)"
              />
              <FormControlLabel
                className="checkbox"
                control={
                  <Checkbox
                    sx={{ color: "gray" }}
                    // value={checkeRemeber}
                    // onClick={handleRemember}
                  />
                }
                label="Adrian Ortlieb (adrian.ortlieb@gmail.com)"
              />
              <FormControlLabel
                className="checkbox"
                control={
                  <Checkbox
                    sx={{ color: "gray" }}
                    // value={checkeRemeber}
                    // onClick={handleRemember}
                  />
                }
                label="Adrian Ortlieb (adrian.ortlieb@gmail.com)"
              />
              <FormControlLabel
                className="checkbox"
                control={
                  <Checkbox
                    sx={{ color: "gray" }}
                    // value={checkeRemeber}
                    // onClick={handleRemember}
                  />
                }
                label="Adrian Ortlieb (adrian.ortlieb@gmail.com)"
              />
              <FormControlLabel
                className="checkbox"
                control={
                  <Checkbox
                    sx={{ color: "gray" }}
                    // value={checkeRemeber}
                    // onClick={handleRemember}
                  />
                }
                label="Adrian Ortlieb (adrian.ortlieb@gmail.com)"
              />
              <FormControlLabel
                className="checkbox"
                control={
                  <Checkbox
                    sx={{ color: "gray" }}
                    // value={checkeRemeber}
                    // onClick={handleRemember}
                  />
                }
                label="Adrian Ortlieb (adrian.ortlieb@gmail.com)"
              />
              <FormControlLabel
                className="checkbox"
                control={
                  <Checkbox
                    sx={{ color: "gray" }}
                    // value={checkeRemeber}
                    // onClick={handleRemember}
                  />
                }
                label="Adrian Ortlieb (adrian.ortlieb@gmail.com)"
              />
              <FormControlLabel
                className="checkbox"
                control={
                  <Checkbox
                    sx={{ color: "gray" }}
                    // value={checkeRemeber}
                    // onClick={handleRemember}
                  />
                }
                label="Adrian Ortlieb (adrian.ortlieb@gmail.com)"
              />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Box className="type-tab-panel filter-tab-panel">
              <FormControlLabel
                className="checkbox"
                control={
                  <Checkbox
                    sx={{ color: "gray" }}
                    // value={checkeRemeber}
                    // onClick={handleRemember}
                  />
                }
                label="Account Activation Updated"
              />
              <FormControlLabel
                className="checkbox"
                control={
                  <Checkbox
                    sx={{ color: "gray" }}
                    // value={checkeRemeber}
                    // onClick={handleRemember}
                  />
                }
                label="Billing Statement Line Added"
              />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Box className="user-tab-panel filter-tab-panel">
              <FormControlLabel
                className="checkbox"
                control={
                  <Checkbox
                    sx={{ color: "gray" }}
                    // value={checkeRemeber}
                    // onClick={handleRemember}
                  />
                }
                label="All Last 30 Days"
              />
              <FormControlLabel
                className="checkbox"
                control={
                  <Checkbox
                    sx={{ color: "gray" }}
                    // value={checkeRemeber}
                    // onClick={handleRemember}
                  />
                }
                label="Last 30 Days"
              />
            </Box>
          </TabPanel>
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", ml: "240px", p: "20px" }}
        >
          <Button className="filter-btn">Apply Filter</Button>
          <Button className="cancel-btn">Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
